"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _hooks = require("@nicbase/hooks");

var _nicbaseReducers = require("nicbase-reducers");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var compare = function compare(prevAsset, nextAsset) {
  if (prevAsset.name === null) {
    return 1;
  }

  if (nextAsset.name === null) {
    return -1;
  }

  return prevAsset.name.localeCompare(nextAsset.name);
};

var useTourboardAssets = function useTourboardAssets() {
  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePortalAssets = (0, _hooks.usePortalAssets)(portalId),
      _usePortalAssets$data = _usePortalAssets.data,
      portalAssets = _usePortalAssets$data === void 0 ? [] : _usePortalAssets$data,
      isLoadingAssets = _usePortalAssets.isLoading;

  var _usePortalCoupledAsse = (0, _hooks.usePortalCoupledAssets)(portalId),
      _usePortalCoupledAsse2 = _usePortalCoupledAsse.data,
      portalCoupledAssets = _usePortalCoupledAsse2 === void 0 ? [] : _usePortalCoupledAsse2,
      isLoadingCoupledAssets = _usePortalCoupledAsse.isLoading;

  var assets = (0, _react.useMemo)(function () {
    return [].concat(_toConsumableArray(portalAssets), _toConsumableArray(portalCoupledAssets)).sort(compare);
  }, [portalAssets, portalCoupledAssets]);
  return {
    data: assets,
    isLoading: isLoadingAssets || isLoadingCoupledAssets
  };
};

var _default = useTourboardAssets;
exports["default"] = _default;